"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = void 0;
class Context {
    constructor(data, span) {
        this.data = data;
        this.span = span;
    }
    static empty() {
        return new Context(new Map());
    }
    getData(key) {
        if (!this.data.has(key)) {
            return null;
        }
        return this.data.get(key);
    }
    withData(key, value) {
        const newMap = new Map(this.data);
        newMap.set(key, value);
        return new Context(newMap, this.span);
    }
    withSpan(span) {
        return new Context(new Map(this.data), span);
    }
    getSpan() {
        return this.span;
    }
}
exports.Context = Context;
//# sourceMappingURL=Context.js.map